/**
 * Hide Directive
 *
 * @since: 2018-07-10
 * @author: yeonggeun.song
 */

export default {
  name: 'global-hide',
  bind (el, binding) {
    const handler = (e) => {
      if ((e && e.target && (!el.contains(e.target) && el !== e.target))) {
        binding.value(e)
      }
    }
    el.closeItemBox = handler
    document.addEventListener('mousedown', handler)
  },
  inserted () {},
  update () {},
  componentUpdated () {},
  unbind (el) {
    document.removeEventListener('mousedown', el.closeItemBox)
    el.closeItemBox = null
  }
}
